<template>
  <div class="life-page">
    <section class="life-panel">
      <div class="life-panel__head">
        <h2 class="life-panel__title">{{ form.productId ? '编辑周边游商品' : '新增周边游商品' }}</h2>
        <div>
          <el-button @click="$router.push('/travel/productList')">返回列表</el-button>
          <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
          <el-button
            v-if="form.productId && form.saleStatus !== 'ON_SALE'"
            type="success"
            :loading="publishing"
            @click="publish"
          >上架</el-button>
        </div>
      </div>

      <h3 class="section-title">基本信息</h3>
      <el-form ref="formRef" :model="form" :rules="rules" label-width="130px">
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="商品名称" prop="productName">
              <el-input v-model="form.productName" maxlength="60" show-word-limit />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品类型" prop="productType">
              <el-select v-model="form.productType" style="width: 100%">
                <el-option label="景区" value="SCENIC" />
                <el-option label="线路" value="ROUTE" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="商品副标题" prop="subtitle">
              <el-input v-model="form.subtitle" maxlength="100" show-word-limit />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出发地" prop="departureCity">
              <el-input v-model="form.departureCity" maxlength="30" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="游玩天数" prop="durationDays">
              <el-input-number v-model="form.durationDays" :min="1" :max="30" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="标签">
              <el-select
                v-model="form.tags"
                multiple
                filterable
                allow-create
                default-first-option
                placeholder="最多5个，每项不超过8字"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否推荐">
              <el-switch v-model="form.recommended" active-value="Y" inactive-value="N" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序">
              <el-input-number v-model="form.sortOrder" :min="0" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单单人数上限">
              <el-input-number v-model="form.maxTravelersPerOrder" :min="1" :max="99" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="免费取消截止小时">
              <el-input-number v-model="form.cancelBeforeHours" :min="0" :max="720" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="预订须知摘要">
              <el-input v-model="form.bookingNotice" type="textarea" :rows="3" maxlength="300" show-word-limit />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="列表封面" prop="coverUrl">
              <upload-image-url
                ref="coverUpload"
                :image-count="1"
                @notifyUploadCoverImage="urls => onImageChange('coverUrl', urls)"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="顶部主图" prop="heroUrl">
              <upload-image-url
                ref="heroUpload"
                :image-count="1"
                @notifyUploadCoverImage="urls => onImageChange('heroUrl', urls)"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="详情长图" prop="detailImageUrl">
              <upload-image-url
                ref="detailUpload"
                :image-count="1"
                @notifyUploadCoverImage="urls => onImageChange('detailImageUrl', urls)"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <h3 class="section-title">出发批次</h3>
      <div style="margin-bottom: 12px">
        <el-button size="small" icon="el-icon-plus" @click="addBatch">新增批次</el-button>
      </div>
      <el-table :data="form.batches" border>
        <el-table-column label="出发时间" min-width="180">
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.departureTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="出发时间"
              style="width: 100%"
            />
          </template>
        </el-table-column>
        <el-table-column label="销售价(元)" width="120">
          <template slot-scope="scope">
            <el-input v-model="scope.row.salePriceYuan" />
          </template>
        </el-table-column>
        <el-table-column label="划线价(元)" width="120">
          <template slot-scope="scope">
            <el-input v-model="scope.row.marketPriceYuan" />
          </template>
        </el-table-column>
        <el-table-column label="总库存" width="100">
          <template slot-scope="scope">
            <el-input v-model="scope.row.totalStock" />
          </template>
        </el-table-column>
        <el-table-column label="销售截止" min-width="180">
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.saleEndTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="销售截止"
              style="width: 100%"
            />
          </template>
        </el-table-column>
        <el-table-column label="状态" width="120">
          <template slot-scope="scope">
            <el-select v-model="scope.row.saleStatus" style="width: 100%">
              <el-option label="可售" value="ON_SALE" />
              <el-option label="停售" value="STOPPED" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80" align="center">
          <template slot-scope="scope">
            <el-button type="text" style="color:#f56c6c" @click="form.batches.splice(scope.$index, 1)">移除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <h3 class="section-title">销售状态</h3>
      <p>当前状态：{{ statusLabel(form.saleStatus) }}。草稿可保存不完整资料；上架前将由服务端校验图片与未来可售批次。</p>
    </section>
  </div>
</template>

<script>
import UploadImageUrl from '@/components/upload/UploadImageUrl'
import { getProduct, saveProduct, updateProduct, publishProduct } from '@/api/travel/travelApi'

function emptyForm() {
  return {
    productId: '',
    productName: '',
    subtitle: '',
    productType: 'SCENIC',
    departureCity: '',
    durationDays: 1,
    tags: [],
    coverUrl: '',
    heroUrl: '',
    detailImageUrl: '',
    bookingNotice: '',
    maxTravelersPerOrder: 9,
    cancelBeforeHours: 24,
    recommended: 'N',
    sortOrder: 100,
    saleStatus: 'DRAFT',
    version: '0',
    batches: []
  }
}

export default {
  name: 'TravelProductEdit',
  components: { UploadImageUrl },
  data() {
    return {
      saving: false,
      publishing: false,
      form: emptyForm(),
      rules: {
        productName: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
        subtitle: [{ required: true, message: '请输入副标题', trigger: 'blur' }],
        productType: [{ required: true, message: '请选择类型', trigger: 'change' }],
        departureCity: [{ required: true, message: '请输入出发地', trigger: 'blur' }],
        durationDays: [{ required: true, message: '请输入游玩天数', trigger: 'change' }]
      }
    }
  },
  created() {
    const productId = this.$route.query.productId
    if (productId) this.load(productId)
  },
  methods: {
    statusLabel(status) {
      return ({ DRAFT: '草稿', ON_SALE: '已上架', OFF_SALE: '已下架', ARCHIVED: '已归档' })[status] || status || '草稿'
    },
    fenToYuan(fen) {
      if (fen === null || fen === undefined || fen === '') return ''
      return (Number(fen) / 100).toFixed(2)
    },
    onImageChange(field, urls) {
      this.form[field] = (urls && urls[0]) || ''
    },
    syncUploads() {
      this.$nextTick(() => {
        if (this.$refs.coverUpload) this.$refs.coverUpload.setImages(this.form.coverUrl ? [this.form.coverUrl] : [])
        if (this.$refs.heroUpload) this.$refs.heroUpload.setImages(this.form.heroUrl ? [this.form.heroUrl] : [])
        if (this.$refs.detailUpload) this.$refs.detailUpload.setImages(this.form.detailImageUrl ? [this.form.detailImageUrl] : [])
      })
    },
    addBatch() {
      this.form.batches.push({
        batchId: '',
        departureTime: '',
        saleEndTime: '',
        salePriceYuan: '',
        marketPriceYuan: '',
        totalStock: '10',
        saleStatus: 'ON_SALE'
      })
    },
    async load(productId) {
      try {
        const res = await getProduct({ productId })
        const data = res.data || {}
        let tags = []
        if (data.tagJson) {
          try { tags = JSON.parse(data.tagJson) } catch (e) { tags = [] }
        }
        this.form = {
          ...emptyForm(),
          ...data,
          durationDays: Number(data.durationDays || 1),
          maxTravelersPerOrder: Number(data.maxTravelersPerOrder || 9),
          cancelBeforeHours: Number(data.cancelBeforeHours || 24),
          sortOrder: Number(data.sortOrder || 100),
          tags,
          batches: (data.batches || []).map(b => ({
            batchId: b.batchId,
            departureTime: b.departureTime,
            saleEndTime: b.saleEndTime,
            salePriceYuan: this.fenToYuan(b.salePriceFen),
            marketPriceYuan: this.fenToYuan(b.marketPriceFen),
            totalStock: String(b.totalStock == null ? '' : b.totalStock),
            saleStatus: b.saleStatus || 'ON_SALE'
          }))
        }
        this.syncUploads()
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      }
    },
    buildPayload() {
      if ((this.form.tags || []).length > 5) {
        throw new Error('标签最多5个')
      }
      for (const tag of this.form.tags || []) {
        if (String(tag).length > 8) throw new Error('单个标签不超过8字')
      }
      return {
        productId: this.form.productId || undefined,
        productName: this.form.productName,
        subtitle: this.form.subtitle,
        productType: this.form.productType,
        departureCity: this.form.departureCity,
        durationDays: String(this.form.durationDays),
        coverUrl: this.form.coverUrl,
        heroUrl: this.form.heroUrl,
        detailImageUrl: this.form.detailImageUrl,
        bookingNotice: this.form.bookingNotice,
        maxTravelersPerOrder: String(this.form.maxTravelersPerOrder),
        cancelBeforeHours: String(this.form.cancelBeforeHours),
        recommended: this.form.recommended || 'N',
        sortOrder: String(this.form.sortOrder),
        version: this.form.version,
        tags: this.form.tags || [],
        batches: (this.form.batches || []).map(b => ({
          batchId: b.batchId || undefined,
          departureTime: b.departureTime,
          saleEndTime: b.saleEndTime,
          salePriceYuan: b.salePriceYuan,
          marketPriceYuan: b.marketPriceYuan,
          totalStock: String(b.totalStock),
          saleStatus: b.saleStatus || 'ON_SALE'
        }))
      }
    },
    async submit() {
      try {
        await this.$refs.formRef.validate()
      } catch (e) {
        return false
      }
      this.saving = true
      try {
        const payload = this.buildPayload()
        if (payload.productId) {
          await updateProduct(payload)
          this.$message.success('保存成功')
          await this.load(payload.productId)
        } else {
          const res = await saveProduct(payload)
          const productId = res.data && res.data.productId
          this.$message.success('创建成功')
          await this.$router.replace({ path: '/travel/productEdit', query: { productId } })
          await this.load(productId)
        }
        return true
      } catch (e) {
        if (e && e.message) this.$message.error(e.message)
        return false
      } finally {
        this.saving = false
      }
    },
    async publish() {
      this.publishing = true
      try {
        const saved = await this.submit()
        if (!saved) return
        await publishProduct({ productId: this.form.productId, version: this.form.version })
        this.$message.success('上架成功')
        await this.load(this.form.productId)
      } catch (e) {
        if (e && e.message) this.$message.error(e.message)
      } finally {
        this.publishing = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import './life.scss';
.section-title {
  margin: 20px 0 12px;
  font-size: 15px;
  font-weight: 600;
}
</style>
